import { ApiClient } from '@webapp/core/services/ApiClient'
import { TutorialRepository } from './TutorialRepository'

export const tutorialRepository = new TutorialRepository({
  httpClient: ApiClient,
})
